var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1.56635 9.30669C1.82635 9.68002 2.28635 9.89335 2.81302 9.89335H5.54635C5.72635 9.89335 5.89302 9.96669 6.00635 10.1C6.12635 10.2334 6.17302 10.42 6.14635 10.6134L5.80635 12.8C5.65969 13.4534 6.09302 14.1867 6.74635 14.4067C7.35302 14.6334 8.06635 14.3267 8.35302 13.8934L11.1597 9.71335L11.2397 9.58002V3.68669L11.1397 3.58669L9.02635 1.95335C8.74635 1.67335 8.11302 1.52002 7.66635 1.52002H5.06635C4.17302 1.52002 3.27302 2.19335 3.07302 3.01335L1.43302 8.00669C1.26635 8.48002 1.31302 8.94669 1.56635 9.30669Z",
    fill: "#C72929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5266 11.7399H13.2132C14.2466 11.7399 14.6666 11.3399 14.6666 10.3533V3.65327C14.6666 2.6666 14.2466 2.2666 13.2132 2.2666H12.5266C11.4932 2.2666 11.0732 2.6666 11.0732 3.65327V10.3599C11.0732 11.3399 11.4932 11.7399 12.5266 11.7399Z",
    fill: "#C72929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.54859d075a83787e262be0c63159c414.svg";
export { ForwardRef as ReactComponent };